import type { InboxMessageFragment } from "@qw/graphql";
import { MessageSender as MessageSenderView } from "@qw/ui";
import type { ComponentProps, FC } from "react";

import { useConversation } from "../providers/use-conversation";
import { MessageActions } from "./message-actions";

export interface MessageSenderProps extends ComponentProps<"header"> {
  message: InboxMessageFragment;
  isMessageOpen: boolean;
}

export const MessageSender: FC<MessageSenderProps> = ({ message, ...props }) => {
  const { displayHeaders, isReadOnly } = useConversation();

  return (
    <MessageSenderView
      {...props}
      message={message}
      displayHeaders={displayHeaders}
      actions={!isReadOnly && <MessageActions message={message} />}
    />
  );
};
